import { Button } from '../../components/Button'
import { Card } from '../../components/Card'
import { useAuth } from '../../hooks/useAuth'
import { AppLayout } from '../../layouts/AppLayout'
import { getAccountUrl } from '../../services/keycloak'
import { styled } from '../../setup'
import { borders, colors, spacing, typography } from '../../theme'

const Container = styled('div')`
  max-width: 600px;
  margin: 0 auto;
`

const Section = styled('section')`
  margin-bottom: ${spacing['2xl']};
  padding-bottom: ${spacing['2xl']};
  border-bottom: ${borders.width} solid ${colors.border};

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`

const SectionTitle = styled('h2')`
  color: ${colors.textPrimary};
  font-size: ${typography.fontSizeLg};
  font-weight: ${typography.fontWeightSemibold};
  margin: 0 0 ${spacing.md} 0;
`

const Description = styled('p')`
  color: ${colors.textSecondary};
  font-size: ${typography.fontSizeBase};
  margin: 0 0 ${spacing.lg} 0;
  line-height: ${typography.lineHeight};
`

const EmailDisplay = styled('p')`
  color: ${colors.textSecondary};
  font-size: ${typography.fontSizeBase};
  margin: 0;
`

export function SettingsPage() {
  const { identity, logout } = useAuth()

  const handlePasswordReset = () => {
    window.location.href = getAccountUrl()
  }

  return (
    <AppLayout>
      <Container>
        <Card title="Settings">
          <Section>
            <SectionTitle>Account Security</SectionTitle>
            <Description>
              Manage your password and security settings through our secure login provider.
            </Description>
            <Button variant="secondary" onClick={handlePasswordReset}>
              Manage Password & Security
            </Button>
          </Section>

          <Section>
            <SectionTitle>Email</SectionTitle>
            <EmailDisplay>{identity.value?.email || 'Not set'}</EmailDisplay>
          </Section>

          <Section>
            <SectionTitle>Log Out</SectionTitle>
            <Description>Log out of your account on this device.</Description>
            <Button variant="danger" onClick={() => logout()}>
              Log Out
            </Button>
          </Section>
        </Card>
      </Container>
    </AppLayout>
  )
}
